import axios from "axios";
import { API_BASE_URL } from "../../config/Config";

export const Get_Pooja_App_Details = async (slug, header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/app-pooja`, {
            params: {
                 pooja_slug:slug
                
            },
            headers: header 
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const Get_Pandit_List = async ({ category_id, latitude, longitude }) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/pandit-list`, {
            category_id,
            latitude,
            longitude
        });
        return response.data;
    } catch (error) {
        return error.response || error;
    }
};
export const Get_Pooja_Detail = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pooja-list`, {
            params: {
               pooja_slug:slug
            },
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const Get_Pooja_List = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pooja-list`, {
            params: {
                category_slug:slug
                
            },
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const Get_Pooja_List_Auth = async (slug,header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/app-pooja`, {
            params: {
                category_slug:slug
                
            },
            headers: header 
        })
        return response;
    } catch (error) {
        return error;
    }
};

export const Get_Pooja_Category_List = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pooja-list`,);
        return response;
    } catch (error) {
        return error;
    }
};


export const Get_Pooja_List_Category = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/app-pooja`, { headers: header })
        return response;
    } catch (error) {
        return error;
    }
};



// user-booked-pooja-list
export const Get_User_Booked_Pooja_List = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-booked-pooja-list`, { headers: header });
        return response;
    } catch (error) {
        return error;
    }
};

export const Get_Pooja_Invoice_Details = async (id, headers = {}) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pooja-details`, {
            params: { pooja_id: id },
            headers,
        });
        return response;
    } catch (error) {
        return error;
    }
};


export const Get_Pooja_List_Category_id = async ({ category_id, pooja_date ,header}) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/app-pooja`, {
            params: {
                category_id,
                pooja_date,
                
            },
            headers: header 
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <---------- Get Pooja details ----------->
export const Get_Pooja_List_Details = async ({ id, category_id }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-pooja-list?id=id&category_id=category_id`, {
            params: {
                id,
                category_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <---------- Get Pooja details ----------->
export const Get_Pooja_List_app_Details = async (id, category_id, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/app-pooja-list?id=id&category_id=category_id`, {
            params: {
                id,
                category_id
            }, headers: headers
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Book Pooja -------------->
export const Book_Pooja = async (data, header) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/book-pooja`, data, { headers: header });
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Book Pooja -------------->
export const Astro_Book_pooja_Order_List = async ({ status }, headers) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/astro-pooja-orders`,
            {
                params: {
                    status
                }
                , headers: headers
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Book Pooja -------------->
export const Pooja_Status_Update = async (formData, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/pooja-status-update`, formData,
             {
                 headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data",
                 } 
                });
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Book Pooja -------------->
export const Post_pooja_review = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-pooja-review`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- pooja-cancel-by-user ------------->
export const User_Booked_Pooja_Cancel = async (data, headers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/cancel-pooja`, 
            data, 
            { headers: { 'Content-Type': 'application/json', ...headers } }
        );
        return response;
    } catch (error) {
        console.error("Error cancelling order:", error);
        return error;
    }
};
